import React, { useState } from 'react';
import axios from '../../axios';
import { useNavigate } from 'react-router-dom';
import { Form, Button, Container } from 'react-bootstrap';

const AddStudent = () => {
  const [student, setStudent] = useState({
    studentId: '',
    examNumber: '',
    name: '',
    citizenId: '',
    birthDate: '',
    majorCode: '',
    majorName: '',
    admissionMethodCode: '',
    admissionOrder: '',
    expectedEnrollmentDate: '',
    expectedEnrollmentLocation: '',
    notes: ''
  });

  const navigate = useNavigate();

  const handleChange = (e) => {
    setStudent({ ...student, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post('/students', student, {
        headers: { 'x-auth-token': localStorage.getItem('token') }
      });
      navigate('/students'); // Redirect to student list after adding
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Container>
      <h2>Add Student</h2>
      <Form onSubmit={handleSubmit}>
        {Object.keys(student).map((key) => (
          <Form.Group controlId={`form${key}`} key={key}>
            <Form.Label>{key}</Form.Label>
            <Form.Control
              type={key === 'birthDate' || key === 'expectedEnrollmentDate' ? 'date' : 'text'}
              name={key}
              value={student[key]}
              onChange={handleChange}
              required
            />
          </Form.Group>
        ))}
        <Button variant="primary" type="submit">Add Student</Button>
      </Form>
    </Container>
  );
};

export default AddStudent;
